<script setup lang="ts">
import { isString } from "lodash"
import type { DefaultProps } from "./Default.props"
const props = defineProps<DefaultProps>()

const { title } = toRefs(props)

const isHovered = ref(false)

const href = computed(() =>
  isString(props?.link) ? props?.link : props?.link?.path
)
</script>

<template>
  <AppLink :id="id" :to="href" class="block h-full">
    <div class="inline-block h-full w-full">
      <div
        class="
          relative
          mx-auto
          max-h-[228px] max-w-[228px]
          overflow-hidden
          rounded-[130px_130px_10px_10px]
        "
      >
        <UtilsWrapperImage
          v-if="image"
          sizes="145px md:228px lg:228px xl:228px"
          class="wrapper-image-full-container-centered"
          v-bind="image"
        />
      </div>

      <p
        v-if="title"
        class="mouse-medium md:hyppo-semibold mt-1 text-center md:mt-4"
        :class="{ underline: isHovered }"
      >
        {{ title }}
      </p>
    </div>
  </AppLink>
</template>
